import React from "react"
import { useTranslation } from "react-i18next"

import classes from "./OhOrderNote.module.scss"

const OhOrderNote = props => {
  const { order } = props

  const [t] = useTranslation()

  if (!order.note) return null

  return (
    <div className={classes["delivery-address"]}>
      <span>{t("توضیحات_سفارش")}</span>
      <div className={classes["bold"]}>
        {order.note}
      </div>
    </div>
  )
}

export default OhOrderNote